<template>
  <span>
    <el-button type="primary" @click="dialogVisible = true">更改返利使用</el-button>

    <el-dialog
      title="更改返利使用"
      :visible.sync="dialogVisible"
      width="800px"
      top="0"
    >
      <div style="margin-bottom: 10px">
        <span
          v-if="yanzheng && setAllocatedAmount(allow) > availableRebateAmount"
          style="display: inline-block; margin-right: 10px"
        >
          当前合同最大可用返利金额：
          {{ $numToFixed(availableRebateAmount) }}元;
        </span>
        <span
          v-if="yanzheng && setAllocatedAmount(allow) <= availableRebateAmount"
          style="display: inline-block; margin-right: 10px"
        >
          当前合同最大可用返利金额：{{ $numToFixed(setAllocatedAmount(allow)) }}元;</span>
        <span style="display: inline-block">
          已分配返利金额：{{ totalChoose }}元
        </span>
      </div>

      <rabate-use
        title="添加可用返利"
        style="float: right"
        need-reload
        :allow="allow"
        :available-rebate-amount="availableRebateAmount"
        :exclude-list="chooseList"
        :household-products="householdProducts"
        @chooesSuccess="chooseSuccess"
      />

      <el-table :data="chooseList" style="width: 100%" border>
        <el-table-column label="返利编号" align="left" prop="rebateNumber" />
        <el-table-column
          label="可用余额"
          align="right"
          header-align="left"
          prop="availableAmount"
        />
        <el-table-column label="返利类型" align="left" prop="strRebateType" />
        <el-table-column label="使用金额" align="right" header-align="left" prop="useAmount">
          <template v-slot="{ row }">
            <el-input-number
              v-model="row.useAmount"
              size="mini"
              :min="0"
              :max="row.availableAmount"
              :controls="false"
              style="width: 100%"
            />
          </template>
        </el-table-column>
        <el-table-column label="删除">
          <template v-slot="{ $index }">
            <el-button type="text" @click="removeRow($index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmTransfer">确认</el-button>
      </span>
    </el-dialog>
  </span>
</template>
<script type="es6">
import { MathAdd, MathMulti } from '@/libs/util';
import rabateUse from './rabateUse';
export default {
  data () {
    return {
      dialogVisible: false,
      chooseList: []
    };
  },
  props: {
    title: {
      type: String,
      default: '填选返利'
    },
    // 订单金额
    allow: {
      type: Number,
      default: 0
    },
    // 返利可用余额
    availableRebateAmount: {
      type: Number,
      default: 0
    },
    rebateUsedList: {
      type: Array,
      default: () => { return []; }
    },
    householdProducts: {
      type: [Boolean, Number],
      default: false
    }
  },

  components: {
    rabateUse
  },

  computed: {
    totalChoose () {
      let count = 0;
      this.chooseList.forEach((item) => {
        count = MathAdd(count, item.useAmount);
      });
      return count;
    }
  },

  methods: {
    // 设置分配金额
    setAllocatedAmount (val) {
      if (this.$route.query.rcontractType === '换货合同') {
        return MathMulti(val, 0.3);
      }
      return val;
    },

    removeRow (index) {
      this.chooseList.splice(index, 1);
    },

    confirmTransfer () {
      // 判断 订单金额 * 30% > 返利可用余额
      if (this.setAllocatedAmount(this.allow) > this.availableRebateAmount) {
        // 已选返利金额 > 返利可用余额
        if (Number(this.totalChoose) > this.availableRebateAmount) {
          return (this.$notify.warning('不可超过最大可用返利金额'));
        }
      } else {
        if (this.$route.query.rcontractType === '换货合同') {
          // 已选返利金额 > 订单金额 * 30%
          if (Number(this.totalChoose) > MathMulti(this.allow, 0.3)) {
            return (this.$notify.warning('不可超过最大可用返利金额'));
          }
        } else {
          // 已选返利金额 > 订单金额
          if (Number(this.totalChoose) > this.allow) {
            return (this.$notify.warning('不可超过最大可用返利金额'));
          }
        }
      }

      let list = [];
      this.chooseList.forEach((item) => {
        list.push({
          rebateNumber: item.rebateNumber,
          useAmount: item.useAmount,
          strRebateType: item.strRebateType,
          availableAmount: item.availableAmount
        });
      });
      this.$emit('chooesSuccess', { list, total: this.$numToFixed(this.totalChoose) });
      this.dialogVisible = false;
    },
    chooseSuccess (val) {
      this.chooseList = [...this.chooseList, ...val.list];
    }
  },
  mounted () {
    this.chooseList = this.rebateUsedList;
  }
};
</script>
<style lang="less"></style>
